var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var _a, _b;
import { IdTournamentPersistence } from "../features/tournament-building/IdTournamentPersistence";
import { PersistenceMode } from "./PersistenceMode";
import { IdSoundGroup } from "./sound/IdSoundGroup";
var PersistenceStorageKey = "Game";
var initialQuestIntro = {
    visitedQuestIntroIds: new Set(),
};
var initialDogPersistence = {
    lastTreatTimestamp: undefined,
};
var initialAnimationSettings = {
    animationEnabled: false,
    autoAnimation: true,
    fpsLimit: 60,
};
var initial = {
    animationSettings: initialAnimationSettings,
    blogVersion: 0,
    clickedGrowthOffers: [],
    contractData: {},
    coopPreviousLevel: Number.MAX_VALUE,
    coopPreviousRanking: Number.MAX_VALUE,
    credentials: {},
    doghouse: initialDogPersistence,
    fbConnected: false,
    lastBooster: -1,
    lastProduction: {},
    lastRankingUpdate: 0,
    lastWebOnlyOfferNotification: 0,
    logging: undefined,
    playerLeaguePreviousRanking: Number.MAX_VALUE,
    questIntroIds: initialQuestIntro,
    settings: (_a = {},
        _a[IdSoundGroup.Global] = false,
        _a[IdSoundGroup.Music] = false,
        _a[IdSoundGroup.Sound] = false,
        _a),
    testCredentials: {},
    tournamentInfo: (_b = {},
        _b[IdTournamentPersistence.LastTournament] = 0,
        _b[IdTournamentPersistence.Confirmed] = false,
        _b),
    tracking: {},
    tutorial: {},
    version: undefined,
};
var UtilPersistence = /** @class */ (function () {
    function UtilPersistence() {
        var _this = this;
        this.getValue = function (id, defaultValue) {
            var value = _this.data[id];
            if ((value == undefined ||
                (value.constructor === Object && Object.keys(value).length === 0)) &&
                defaultValue != undefined) {
                return defaultValue;
            }
            return value;
        };
        this.setValue = function (id, data, mode, force) {
            if (mode === void 0) { mode = PersistenceMode.Update; }
            if (force === void 0) { force = false; }
            switch (mode) {
                case PersistenceMode.Write:
                    _this.data[id] = data;
                    break;
                case PersistenceMode.Update:
                    _this.data[id] = __assign({}, _this.data[id], data);
                    break;
                case PersistenceMode.Reset:
                    _this.data[id] = initial[id];
                    break;
            }
            clearTimeout(_this.setStorageHandle);
            if (force) {
                _this.setDataToStorage(_this.data);
            }
            else {
                // cast to as any is needed because of what setTimeout returns in nodeJS
                _this.setStorageHandle = setTimeout(_this.setDataToStorage, 1000, _this.data);
            }
        };
        this.setDataToStorage = function (data) {
            var serializedData = _this.serialize(data);
            if (serializedData) {
                localStorage.setItem(PersistenceStorageKey, serializedData);
            }
        };
        this.getDataFromStorage = function (defaultValue) {
            var value = _this.deserialize(localStorage.getItem(PersistenceStorageKey)) || defaultValue;
            return value;
        };
        this.serialize = function (data) {
            if (!data) {
                return undefined;
            }
            try {
                return JSON.stringify(data);
            }
            catch (_a) {
                return undefined;
            }
        };
        this.deserialize = function (serializedData) {
            if (!serializedData) {
                return undefined;
            }
            try {
                return JSON.parse(serializedData);
            }
            catch (_a) {
                return undefined;
            }
        };
        this.data = this.getDataFromStorage(initial);
    }
    return UtilPersistence;
}());
export var utilPersistence = new UtilPersistence();



//////////////////
// WEBPACK FOOTER
// ./src/utils/utilPersistence.ts
// module id = 40
// module chunks = 3